import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { RedirectType } from "src/types/apps";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { GetAppDataPayload } from "./NetTypes";

export async function getAppRedirectsRequest({ orgId, appId }: GetAppDataPayload) {
	return await apiClient
		.get(API.QUERY.ORGANIZATIONS.REDIRECTS.ALL(orgId, appId))
		.then((res) => res.data);
}

export function useGetAppRedirectsRequest(ids: GetAppDataPayload) {
	return useQuery<RedirectType[], AxiosError>({
		queryKey: ["apps", "redirects", ids.appId],
		queryFn: () => getAppRedirectsRequest(ids)
	});
}
